export default __webpack_public_path__ + "static/media/ManishM.129145cf.jpg";